var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarS = function SvgDefaultAvatarS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7 55.7c6.1 0 11.1-3.5 11.1-9.2 0-5.8-4.6-7.8-11-9-4.5-.8-7.4-1.6-7.4-5 0-2.9 2.7-5.1 6.5-5.1 3.9 0 6.4 2.1 7.7 5.6.4 1 .8 1.9 1.7 1.9.7 0 1.3-.9 1.3-2.5 0-3.3-1.6-7.4-3.3-7.4-.9 0-1 .8-1.7.8-.4 0-1-.2-1.6-.5-1.2-.4-2.7-.8-4.6-.8-6.2 0-10.5 3.9-10.5 8.8 0 5.9 4.2 7.7 10.7 8.9 4.6.9 7.6 1.8 7.6 5.2 0 3.1-2.7 5.4-6.7 5.4s-7.4-2.2-8.7-5.2c-.9-2-1.2-3.4-2.1-3.4-.8 0-1.4.9-1.4 2.8 0 3.7 1.8 8 3.5 8 1.1 0 1-.8 1.9-.8.5 0 1.1.3 1.9.6 1.3.4 3 .9 5.1.9z"
  })));
};
export default SvgDefaultAvatarS;